/**
 * Feature flags – set to true to show, false to hide temporarily.
 * Toggle these when you want to re-enable features.
 */
export const SHOW_PRODUCTS_PAGE = false;
export const SHOW_SERVICES_PAGE = false;
export const SHOW_REFERRAL_SYSTEM = false;
export const SHOW_SEASONAL_OFFER_BADGE = false;
export const SHOW_COUPON_CODE = false;
